import Vue from 'vue'
import Vuex from 'vuex'
// import Pa from './modules/a'
// import Pb from './modules/b'
import test from './modules/test'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    test
    // Pa,
    // Pb
  },
  /* test store */
  state: {
    username: 'song kai',
    applyJoinClassOptions: [
      {
        value: '2018-2019学年',
        label: '2018-2019学年',
        children: [
          { value: '国际大一班', label: '国际大一班' },
          { value: '国际大二班', label: '国际大二班' },
          { value: '国际小一班', label: '国际小一班' },
          { value: '国际小二班', label: '国际小二班' },
          { value: '慧智大一班', label: '慧智大一班' },
          { value: '慧智大二班', label: '慧智大二班' },
          { value: '慧智大三班', label: '慧智大三班' },
          { value: '慧智中一班', label: '慧智中一班' },
          { value: '慧智中二班', label: '慧智中二班' },
          { value: '慧智中三班', label: '慧智中三班' },
          { value: '慧智小一班', label: '慧智小一班' },
          { value: '慧智小二班', label: '慧智小二班' },
          { value: '慧智小三班', label: '慧智小三班' }
        ]
      },
      {
        value: '2017-2018学年',
        label: '2017-2018学年',
        children: [
          { value: '国际大一班', label: '国际大一班' },
          { value: '国际大二班', label: '国际大二班' },
          { value: '国际小一班', label: '国际小一班' },
          { value: '国际小二班', label: '国际小二班' },
          { value: '慧智大一班', label: '慧智大一班' },
          { value: '慧智大二班', label: '慧智大二班' },
          { value: '慧智大三班', label: '慧智大三班' },
          { value: '慧智中一班', label: '慧智中一班' },
          { value: '慧智中二班', label: '慧智中二班' },
          { value: '慧智中三班', label: '慧智中三班' },
          { value: '慧智小一班', label: '慧智小一班' },
          { value: '慧智小二班', label: '慧智小二班' },
          { value: '慧智小三班', label: '慧智小三班' }
        ]
      },
      {
        value: '2016-2017学年',
        label: '2016-2017学年',
        children: [
          { value: '2017毕业离园班', label: '2017毕业离园班' }
        ]
      }
    ]
  },
  mutations: {
    pin (state) {
      state.username = state.username + '00'
    }
  },
  actions: {
    pin (context) {
      context.commit('pin')
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js